import React from 'react'
import { Lock, Check, Clock } from 'lucide-react'

const PestanasBloqueadas = ({ estadoPestanas, faseActual, onTabClick }) => {
  const tabs = [
    { key: 'planificar', label: 'P', fullLabel: 'Planificar', color: 'blue' },
    { key: 'hacer', label: 'D', fullLabel: 'Hacer', color: 'green' },
    { key: 'verificar', label: 'C', fullLabel: 'Verificar', color: 'yellow' },
    { key: 'actuar', label: 'A', fullLabel: 'Actuar', color: 'purple' }
  ]

  const getTabStyles = (tab) => {
    const estado = estadoPestanas?.[tab.key]
    if (!estado) return 'bg-gray-200 text-gray-500 cursor-not-allowed'

    if (estado.completada) {
      return 'bg-green-100 text-green-700 border-2 border-green-500'
    }
    
    if (estado.activa) {
      return `bg-${tab.color}-500 text-white border-2 border-${tab.color}-700 shadow-lg`
    }
    
    if (estado.bloqueada) {
      return 'bg-gray-200 text-gray-400 cursor-not-allowed opacity-60'
    }
    
    return 'bg-gray-100 text-gray-600 hover:bg-gray-200'
  }

  const getIcon = (tab) => {
    const estado = estadoPestanas?.[tab.key]
    if (!estado) return null

    if (estado.completada) {
      return <Check className="w-5 h-5" />
    }
    
    if (estado.bloqueada) {
      return <Lock className="w-5 h-5" />
    }
    
    if (estado.activa) {
      return <Clock className="w-5 h-5 animate-pulse" />
    }
    
    return null
  }

  const handleTabClick = (tab) => {
    const estado = estadoPestanas?.[tab.key]
    if (!estado || estado.bloqueada) {
      return
    }
    onTabClick(tab.key)
  }

  return (
    <div className="w-full">
      {/* Tabs */}
      <div className="flex gap-2 mb-6">
        {tabs.map((tab) => {
          const estado = estadoPestanas?.[tab.key]
          
          return (
            <div key={tab.key} className="flex-1 relative group">
              <button
                onClick={() => handleTabClick(tab)}
                disabled={!estado || estado.bloqueada}
                className={`
                  w-full py-4 px-6 rounded-lg font-semibold text-lg
                  transition-all duration-200 flex items-center justify-center gap-2
                  ${getTabStyles(tab)}
                  ${!estado?.bloqueada && 'hover:scale-105'}
                `}
                title={estado?.mensaje || tab.fullLabel}
              >
                <span className="text-2xl font-bold">{tab.label}</span>
                {getIcon(tab)}
              </button>
              
              {/* Tooltip */}
              {estado?.bloqueada && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 
                              hidden group-hover:block z-10">
                  <div className="bg-gray-800 text-white text-sm rounded py-2 px-3 whitespace-nowrap">
                    {estado.mensaje}
                    <div className="absolute top-full left-1/2 transform -translate-x-1/2 
                                  border-4 border-transparent border-t-gray-800"></div>
                  </div>
                </div>
              )}
              
              {/* Progress indicator */}
              {estado && !estado.completada && (
                <div className="mt-2">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className={`h-2 rounded-full transition-all duration-300 bg-${tab.color}-500`}
                      style={{ width: `${estado.progreso}%` }}
                    ></div>
                  </div>
                  <p className="text-xs text-gray-600 mt-1 text-center">
                    {estado.progreso}%
                  </p>
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* Full labels */}
      <div className="flex gap-2 text-center text-sm text-gray-600 mb-4">
        {tabs.map((tab) => (
          <div key={tab.key} className="flex-1">
            {tab.fullLabel}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PestanasBloqueadas
